import { c as _c } from "react/compiler-runtime";
import React, { useRef, useState } from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import CtaButton from 'components/essentials/Cta/CtaButton';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import FormikFirstErrorFieldFocusOnSubmit from 'components/essentials/FormikFirstErrorFieldFocusOnSubmit';
import { logError } from 'commons/logger';
import ValidationError from 'components/consumer/ValidationError';
import useSetZipCodeFromUser from 'global-state/zipCodeFromUser/useSetZipCodeFromUser';
import useZipCodeFromUser from 'global-state/zipCodeFromUser/useZipCodeFromUser';
import useZipCode from 'global-state/zipCode/useZipCode';
import { ZIPCODE_ERROR_MESSAGES } from 'commons/constants';
import useUserLocationFromZipcode from 'hooks/useUserLocationFromZipcode';
import useIsZipCodeServiceable from 'hooks/useIsZipCodeServiceable';
import useScreen from 'hooks/useScreen';
import PDPAlertBar from '../PDP/PDPAlertBar';
const validateZipcodeInput = inputs => {
  const errors = {};
  if (!inputs.zipcode.toString().trim()) {
    errors.zipcode = ZIPCODE_ERROR_MESSAGES.ZIPCODE_IS_EMPTY;
  } else if (!/^\d{5}(-\d{4})?$/.test(inputs.zipcode)) {
    errors.zipcode = ZIPCODE_ERROR_MESSAGES.ZIPCODE_IS_INVALID_FORMAT;
  }
  return errors;
};
const UpdateZipcodeForm = t0 => {
  const $ = _c(15);
  const {
    onUpdateSuccess
  } = t0;
  const zipInputRef = useRef();
  const locationZipCode = useZipCode();
  const [isZipServiceable, setIsZipServiceable] = useState(true);
  const {
    isMobile
  } = useScreen();
  const zipCodeFromUser = useZipCodeFromUser();
  const setZipCodeFromUser = useSetZipCodeFromUser();
  const {
    refetch: getIsZipCodeServiceable
  } = useIsZipCodeServiceable();
  const {
    refetch: getVisitorLocationFromZipcode
  } = useUserLocationFromZipcode();
  const [nonServiceableZipError, setNonServiceableZipError] = useState("");
  const t1 = zipCodeFromUser || locationZipCode || "";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      zipcode: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== getIsZipCodeServiceable || $[3] !== getVisitorLocationFromZipcode || $[4] !== onUpdateSuccess || $[5] !== setZipCodeFromUser) {
    t3 = async (t4, t5) => {
      const {
        zipcode
      } = t4;
      const {
        setFieldError,
        setSubmitting
      } = t5;
      setSubmitting(true);
      if (!zipcode) {
        setFieldError("zipcode", ZIPCODE_ERROR_MESSAGES.ZIPCODE_IS_EMPTY);
        return;
      }
      const trimmedZipCode = zipcode.trim();
      setZipCodeFromUser(trimmedZipCode);
      ;
      try {
        const {
          error: isZipCodeServiceableError,
          nonServiceableZipCodeError,
          isZipCodeServiceable: isServiceable
        } = await getIsZipCodeServiceable(trimmedZipCode);
        if (!isServiceable) {
          setIsZipServiceable(isServiceable);
          if (isZipCodeServiceableError) {
            setFieldError("zipcode", isZipCodeServiceableError);
          }
          if (nonServiceableZipCodeError) {
            setNonServiceableZipError(nonServiceableZipCodeError);
          }
          return;
        }
        const {
          errorMessage: getLocationErrorMessage
        } = await getVisitorLocationFromZipcode(trimmedZipCode);
        if (getLocationErrorMessage) {
          setFieldError("zipcode", getLocationErrorMessage);
          return;
        }
        onUpdateSuccess(isServiceable);
      } catch (t6) {
        const error = t6;
        logError(error);
        setFieldError("zipcode", ZIPCODE_ERROR_MESSAGES.UNEXPECTED_ERROR);
      }
    };
    $[2] = getIsZipCodeServiceable;
    $[3] = getVisitorLocationFromZipcode;
    $[4] = onUpdateSuccess;
    $[5] = setZipCodeFromUser;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isMobile || $[8] !== isZipServiceable || $[9] !== nonServiceableZipError) {
    t4 = t5 => {
      const {
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        handleBlur,
        isSubmitting
      } = t5;
      return <form data-xc="UpdateZipcodeSidebarForm" onSubmit={handleSubmit}><LabeledTextInput errorMessage={touched.zipcode && errors.zipcode ? errors.zipcode : null} id="zipcode" type="zipcode" name="zipcode" label="Zip code" onChange={handleChange} onBlur={handleBlur} autoComplete="zipcode" value={values.zipcode} data-xc="zipcode-field" ref={zipInputRef} autoFocus={!isMobile} /><CtaButton hasArrow={false} color="black" type="submit" styling="solid-button" data-xc="UpdateZipcodeSidebarSubmitButton" block={true} isLoading={isSubmitting}>Update</CtaButton>{errors.formErrors && <ValidationError block={true}>{errors.formErrors}</ValidationError>}<FormikFirstErrorFieldFocusOnSubmit formFieldRefs={{
          zipcode: zipInputRef
        }} />{!isZipServiceable && <PDPAlertBar> {nonServiceableZipError}</PDPAlertBar>}</form>;
    };
    $[7] = isMobile;
    $[8] = isZipServiceable;
    $[9] = nonServiceableZipError;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <Formik initialValues={t2} validate={validateZipcodeInput} onSubmit={t3}>{t4}</Formik>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
UpdateZipcodeForm.propTypes = {
  onUpdateSuccess: PropTypes.func
};
export default UpdateZipcodeForm;